import { z } from 'zod';

import { PayeeId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const SyncPayeeOnEscrowEvent = BaseLoanEvent.extend({
  type: z.literal('syncPayeeOnEscrow'),
  payeeId: PayeeId,
});

export type SyncPayeeOnEscrowEvent = z.infer<typeof SyncPayeeOnEscrowEvent>;
